import { render } from "./ColourSwatchOptions.vue?vue&type=template&id=c62ee1c2&scoped=true"
import script from "./ColourSwatchOptions.vue?vue&type=script&lang=js"
export * from "./ColourSwatchOptions.vue?vue&type=script&lang=js"

import "./ColourSwatchOptions.vue?vue&type=style&index=0&id=c62ee1c2&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c62ee1c2"]])

export default __exports__